/* eslint-disable */

export const CommerceOptionState = {
  Available: 'available',
  Disabled: 'disabled',
  Selected: 'selected'
} as const;
export type CommerceOptionState = typeof CommerceOptionState[keyof typeof CommerceOptionState];
